export const filterData = (data, filterField, filterData, resultField) => {
    const result = data?.filter((item) => item[filterField] === filterData)
    return result[0][resultField]
}